import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  return <section className="bg-navy-800 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-234">
      <div className="mx-auto max-w-5xl" data-id="element-235">
        <div className="grid gap-8 md:grid-cols-2" data-id="element-236">
          {/* Who this is for */}
          <div className="rounded-2xl bg-navy-900 p-8 border border-green-500/20 shadow-lg relative overflow-hidden" data-id="element-237">
            <div className="absolute top-0 left-0 w-full h-1 bg-green-500" data-id="element-238"></div>
            <h3 className="mb-6 text-3xl font-bebas text-white flex items-center gap-3" data-id="element-239">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-green-500/20" data-id="element-240">
                <Check className="h-5 w-5 text-green-500" data-id="element-241" />
              </span>
              ESTO ES PARA TI SI:
            </h3>
            <ul className="space-y-4" data-id="element-242">
              <li className="flex gap-3 text-slate-300" data-id="element-243">
                <Check className="h-6 w-6 flex-shrink-0 text-green-500" data-id="element-244" />
                <span data-id="element-245">
                  <strong className="text-white" data-id="element-246">Inmigrantes hispanos</strong>{' '}
                  (con SSN o ITIN) que quieren establecerse firmemente en USA.
                </span>
              </li>
              <li className="flex gap-3 text-slate-300" data-id="element-247">
                <Check className="h-6 w-6 flex-shrink-0 text-green-500" data-id="element-248" />
                <span data-id="element-249">
                  <strong className="text-white" data-id="element-250">Padres de familia</strong> que
                  necesitan un auto nuevo o una casa más grande pero el crédito
                  se los impide.
                </span>
              </li>
              <li className="flex gap-3 text-slate-300" data-id="element-251">
                <Check className="h-6 w-6 flex-shrink-0 text-green-500" data-id="element-252" />
                <span data-id="element-253">
                  Cualquier persona cansada de pagar{' '}
                  <strong className="text-white" data-id="element-254">intereses abusivos</strong> del
                  20% o más.
                </span>
              </li>
            </ul>
          </div>

          {/* Who this is not for */}
          <div className="rounded-2xl bg-navy-900 p-8 border border-red-500/20 shadow-lg relative overflow-hidden" data-id="element-255">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500" data-id="element-256"></div>
            <h3 className="mb-6 text-3xl font-bebas text-white flex items-center gap-3" data-id="element-257">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-red-500/20" data-id="element-258">
                <X className="h-5 w-5 text-red-500" data-id="element-259" />
              </span>
              ESTO NO ES PARA TI SI:
            </h3>
            <ul className="space-y-4" data-id="element-260">
              <li className="flex gap-3 text-slate-300" data-id="element-261">
                <X className="h-6 w-6 flex-shrink-0 text-red-500" data-id="element-262" />
                <span data-id="element-263">
                  Personas que buscan cometer fraude o borrar deudas legítimas y
                  recientes sin base legal.
                </span>
              </li>
              <li className="flex gap-3 text-slate-300" data-id="element-264">
                <X className="h-6 w-6 flex-shrink-0 text-red-500" data-id="element-265" />
                <span data-id="element-266">
                  Gente que espera que el crédito se arregle solo sin enviar una
                  sola carta al correo.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}